exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer {\n  background-color: #a94442;\n  color: #FFF;\n  padding: 20px; }\n\n.footer__middle p, .footer__right p, .footer__left p, .footer__right a, .footer__left a {\n  color: #FFF;\n  font-size: 12px; }\n\n.svg__social {\n  width: 32%;\n  fill: #FFF; }\n\n@media (max-width: 425px) {\n  .svg__social {\n    width: 30%; } }\n\n.svg--hover:hover {\n  fill: #A60430; }\n\n.footer__right a:hover, .footer__left a:hover {\n  color: #A60430; }\n\n.footer__right {\n  width: 15%; }\n\nimg.img--footer {\n  width: 100px; }\n\n.hidden {\n  display: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./app/shared/css/footer.scss
// module id = 8
// module chunks = 0 1 2 3 4 5 6 7 8 9